import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { change, Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import TargetModal from './target_Modal';
import { renderCheckBox, renderTextField } from '../../../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../../actions/utilAction';
import SortingCustom from '../../../../../components/SortingCustom';
import { getTargetList, deleteTarget } from './actions/targetActions';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { CommonButton } from '../../../../../components/buttons';
import { UpdateDCArchiveStatus } from '../../actions/CurriculumLibrariesActions';

const stylescss = {
    checkbox: {
      marginBottom: 16,
    },
  };

class Target extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            targetId: null,
            programId: props.ProgramIdForTarget,
            selectedLibraryIds: [],     
            ShowArchivedOnly : false,       
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchTargets = this.handleSearchTargets.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.CheckTarget = this.CheckTarget.bind(this);
        this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
    }

    componentWillMount() {
        this.loadData(); 
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_target && nextProps.saved_target !== this.props.saved_target) {
            this.loadData();
        }
        if (nextProps.deleted_target && nextProps.deleted_target !== this.props.deleted_target) {
            this.loadData();
        }
        if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
            this.setState({ selectedLibraryIds : [] },()=>{
                this.ResetAllCheckBoxes();
              this.loadData();
            });      
          }  
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
            pageNumber: page_number || 1,
        };
        this.props.getTargetList(searchObj, this.props.ProgramIdForTarget);
    }

    ResetAllCheckBoxes()
      {
        this.props.targetData != null && this.props.targetData && this.props.targetData.data.forEach((obj, Index) => {
            let idCheck = `Claims[${Index}].Chk`;                
            this.props.dispatch(change('ManageTargetForm', idCheck, false));                
        });
      }

    handleAlertArchiveBatchTargetsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), true, 'MasterTarget');
        Alert.closeAll();
      }
    
      handleArchiveBatchTargetsClick = (event) => {
        Alert.warning('Are you sure you want to archive selected target(s)?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertArchiveBatchTargetsClick,
            //id: obj.id,
          },
        });
      }

      handleAlertUnArchiveBatchTargetsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), false, 'MasterTarget');
        Alert.closeAll();
      }
    
      handleUnArchiveBatchTargetsClick = (event) => {
        Alert.warning('Are you sure you want to unarchive selected target(s)?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertUnArchiveBatchTargetsClick,
            //id: obj.id,
          },
        });
      }

      CheckTarget(e, index, data) {    
        let selectedLibraryIds = this.state.selectedLibraryIds;        
        let isChecked = e.target.checked;
        if (isChecked) {     
            selectedLibraryIds.push(data.id);              
        } else {     
            index = selectedLibraryIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedLibraryIds.splice(index, 1);         
            }      
        }
        this.setState({ selectedLibraryIds });
      }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({ open: true, targetId: null });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSearchTargets() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageTargetForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.setState({ ShowArchivedOnly : false  }, ()=>{this.loadData();});
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, targetId: obj.id });
    }

    handleAlertClick = (event, targetId) => {
        this.props.deleteTarget(targetId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete target details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    handleAdvanceFilterCheck = (input, name) => {
        this.setState({ [name]: input.target.checked },
          () => {
            this.loadData();
          });
      }

    renderData(targetList) {
        targetList = targetList || [];
        if (!targetList.length) {
            return (
                <tr>
                    <td colSpan="7">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return targetList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="5%">
                        <div className="table_custom-check">
                        <Field
                            name={`Claims[${index}].Chk`}
                            component={renderCheckBox}
                            onChange={(e) => this.CheckTarget(e, index, Obj)}
                            style={stylescss.checkbox}
                        />
                        </div>
                    </td>
                    <td>{Obj.domainName}</td>
                    <td>{Obj.programName}</td>
                    <td>{Obj.targetName}</td>
                    <td>{Obj.targetType}</td>
                    {/* <td>{Obj.autoOpen}</td> */}
                    <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    <td>
                        <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    </td>
                </tr>
            )
        })
    }

    targetRender = () => {
        const { handleSubmit, targetData } = this.props;
        let targetList = (targetData && targetData.data) || [];
        let targetMeta = (targetData && targetData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Curriculum Libraries {' > '} {this.props.libraryName} {' > '} {this.props.domainName} {' > '} {this.props.programName} {' > '} Targets</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                <div className="col-sm-2">
                                    <RaisedButton label="Back" primary={true} onTouchTap={() => this.props.onBackClick()} />
                                </div>
                                <div className="col-sm-3">
                                    <RaisedButton label="Add Target" primary={true} onTouchTap={this.handleOpen} />
                                </div>
                                <div className="col-sm-3">
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchTargetsClick(e)} />
                                </div>
                                <div className="col-sm-3">
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && this.state.ShowArchivedOnly ? false : true} label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchTargetsClick(e)} />
                                </div>    
                            </div>
                            <div className="row mt-20">
                                <div className="col-sm-4 field-mr">
                                    <Field
                                    name="ShowArchivedOnly"
                                    label="Show Archived Only"
                                    component={renderCheckBox}
                                    onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                                    />
                                </div>
                                <div className="col-sm-8">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchTargets)}>
                                                <Field
                                                    name="target"
                                                    floatingLabelText="Search"
                                                    maxLength='250'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open && <TargetModal
                             targetId={this.state.targetId}
                             closeDialog={this.handleClose}
                             programId={this.state.programId}
                             domainIdForTarget={this.props.domainIdForTarget}
                             domainName={this.props.domainName}
                             masterDomains={this.props.masterDomains}
                             masterPrograms={this.props.masterPrograms}
                             desiredDailyTrials={this.props.desiredDailyTrials}
                             autoOpenOrder={this.props.autoOpenOrder}
                             targetType={this.props.targetType}
                             responsePercentage={this.props.responsePercentage}
                             consecutiveDays={this.props.consecutiveDays}
                             firstTrialMustBeIndependent={this.props.firstTrialMustBeIndependent}
                             curriculumLibraryId={this.props.curriculumLibraryId}
                             />
                            }
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th width="20%"><SortingCustom noSort={!targetList.length} setSortColumn={this.setSortColumn} columnName='domainName' displayName='Domain' /></th>
                                                <th width="20%"><SortingCustom noSort={!targetList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Program' /></th>
                                                <th width="25%"><SortingCustom noSort={!targetList.length} setSortColumn={this.setSortColumn} columnName='targetName' displayName='Target' /></th>
                                                <th width="15%">Type</th>
                                                {/* <th width="10%">Auto Open</th> */}
                                                <th width="8%">Active</th>
                                                <th width="7%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderData(targetList)}
                                        </tbody>
                                    </table>
                                    {targetMeta && targetMeta['totalPages'] ?
                                        <PaginatorCustom data={targetMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            this.targetRender()
        )
    }
}

Target = reduxForm({
    form: 'ManageTargetForm',
})(Target);

function mapStateToProps(state) {
    return {
        loading: state.target.loading,
        targetData: state.target.targetList,
        saved_target: state.target.saved_targetList,
        deleted_target: state.target.deleted_targetList,
        archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,    
    }
}

export default connect(mapStateToProps, { getTargetList, deleteTarget, UpdateDCArchiveStatus })(Target);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/target/index.js